import { call, type UnassignedEmailPage } from "@baton/api";
import { keys, type Runtime } from "@baton/core";
import { infiniteQueryOptions } from "@tanstack/react-query";

/**
 * 022's Unassigned emails (2026-09-28): the Team's intake emails Baton could not put on one client,
 * read a page at a time. The Clients sidebar counts them from the same cache entry the screen reads,
 * so this read is a module of its own: the sidebar is in the shell's first load, and taking it from
 * `m365/data.ts` would bring every Microsoft 365 read and write into that load with it (FR-015-120,
 * 2026-10-05). It calls its route through `call` rather than `@baton/api`'s `m365` operations, whose
 * module holds every Microsoft 365 operation and would come into the first load whole for this one
 * route (2026-10-05).
 */

/** The page the Unassigned emails screen reads at a time. */
export const UNASSIGNED_PAGE = 25;

interface CursorPageParam {
  readonly cursor: string | null;
}

export function unassignedEmailsQuery(runtime: Runtime, ws: string) {
  return infiniteQueryOptions({
    queryKey: keys.unassignedEmails(ws),
    initialPageParam: { cursor: null },
    getNextPageParam: (last: UnassignedEmailPage): CursorPageParam | undefined => (last.next_cursor === null ? undefined : { cursor: last.next_cursor }),
    queryFn: async ({ pageParam, signal }): Promise<UnassignedEmailPage> =>
      (
        await call(runtime.signedIn, "get", "/api/v1/workspaces/{ws}/m365/unassigned-emails", {
          params: { ws },
          query: { limit: UNASSIGNED_PAGE, ...(pageParam.cursor === null ? {} : { cursor: pageParam.cursor }) },
          signal,
        })
      ).data,
  });
}
